import React, {Component} from 'react'
import {Button, Panel} from '@sabre/spark-react'
import ReactToPrint from 'react-to-print'
import ScreenTemplate from 'shared/components/ScreenTemplate'
import WeatherForm from './WeatherForm/form'
import withProgress from 'shared/hoc/progress/index'
import WeatherResponse from "shared/components/WeatherResponse/index"

export default class Weather extends Component {
    pageTitle = 'Weather'

    constructor(props) {
        super(props)
        this.weatherResponse = React.createRef()
        this.actions = {
            onGetWeather: (params) => this.onGetWeather(params),
            onGetWeatherTypes: () => this.onGetWeatherTypes()
        }
    }

    componentWillUnmount() {
        this.props.actions.resetWeather()
        this.props.actions.resetError()
    }

    onGetWeather(params) {
        this.props.actions.getWeather(params)
    }

    onGetWeatherTypes() {
        this.props.actions.getWeatherTypes()
    }

    render() {
        const PanelWithProgress = withProgress(Panel)
        let message = this.props.error
            ? {type: "warning", title: this.props.error.title, text: this.props.error.text}
            : undefined
        return (
            <ScreenTemplate
                login={this.props.username !== undefined ? this.props.username : 'unknown'}
                activeMenuItem={this.pageTitle}
                actions={{onSignOut: this.props.signOut}}
                message={message}>
                <div className="col-xs-12 spark-mar-b-2">
                    <WeatherForm actions={this.actions} weatherTypes={this.props.types}
                                 loading={this.props.isLoadingTypes} submitDisabled={this.props.isLoading}/>
                </div>
                <div className="col-xs-12">
                    <PanelWithProgress className="min-height-200" loading={this.props.isLoading}>
                        <Panel.Content >
                            <div className="row spark-mar-t-2 spark-mar-2--gte-md">
                                <div className="col-md-12">
                                    <div className="spark-text-right">
                                        <ReactToPrint
                                            trigger={() => (<Button
                                                onClick={()=>{}}
                                                icon="spark-icon-print"
                                                iconOnly
                                                title="Print"
                                                disabled={!this.props.data}
                                                />)}
                                            content={() => this.weatherResponse}
                                            bodyClass="spark-mar-2"
                                        />
                                    </div>
                                    <WeatherResponse ref={el => (this.weatherResponse = el)} airports={this.props.data}/>
                                </div>
                            </div>
                        </Panel.Content>
                    </PanelWithProgress>
                </div>
            </ScreenTemplate>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/weather/components/index.js